var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-gridview',{attrs:{"parentData":{
            tabHeaders: this.dataHeader,
            tabItems: this.dataItems,
            pageTitle: this.pageTitle,
            search: this.search,
            isDelete: true,
        }},on:{"EditItem":function($event){return _vm.editItemHandler($event)},"DeleteItem":function($event){return _vm.deleteItemHandler($event)},"NewPressed":_vm.newRecordHandler}}),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{ data: this.errMsg, isErr: this.isErr }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e(),(_vm.isConfirm)?_c('div',[_c('app-confirm',{attrs:{"parentObject":{
                pageTitleValue: this.confirmCode,
                isConfirm: this.isConfirm,
            }},on:{"confirm":function($event){return _vm.confirmDeleteHandler($event)},"cancelConfirm":function($event){_vm.isConfirm = false}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }